import React, { useEffect } from "react";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import {
  AadhaarAndPanUniqueCheckPayloadType,
  AddClientDirectoryPayloadType,
} from "../../commonTypes/clientDirectoryTypes";
import { resetSession } from "../../redux/auth";
import ClientDirectoryForm from "../../components/ClientDirectory/ClientDirectoryForm";
import {
  CommonHeader,
  ErrorSuccessModal,
  Loader,
} from "../../components/commons";
import { resetGstDetails } from "../../redux/services";
import {
  addClientDirectoryAction,
  clientAadharUniqueCheckAction,
  clientPanUniqueCheckAction,
  resetClientAadharUniqueCheckError,
  resetClientAadharUniqueCheckMessage,
  resetClientAadharUniqueCheckSuccess,
  resetClientDirectoryError,
  resetClientDirectoryList,
  resetClientDirectoryMessage,
  resetClientDirectoryStatusCode,
  resetClientDirectorySuccess,
  resetClientPanUniqueCheckError,
  resetClientPanUniqueCheckMessage,
  resetClientPanUniqueCheckSuccess,
  resetSingleClientDirectory,
} from "../../redux/clientDirectory";
import { Toaster } from "react-hot-toast";

type AppProps = {
  history: any;
  token: string | null;
  error: string | null;
  success: number | null;
  clientAadharUniqueCheckMessage: string | null;
  clientPanUniqueCheckMessage: string | null;
  statusCode: number | null;
  fetching: boolean;
  isState: null | boolean;
  isCity: null | boolean;
  clientAadharUniqueCheckFetching: boolean;
  clientPanUniqueCheckFetching: boolean;
  dispatchResetClientDirectorySuccess: () => void;
  dispatchResetClientDirectoryError: () => void;
  dispatchResetClientDirectoryMessage: () => void;
  dispatchResetClientDirectoryStatusCode: () => void;
  dispatchResetSingleClientDirectory: () => void;
  dispatchResetSession: () => void;
  dispatchResetClientDirectoryList: () => void;
  dispatchResetGstDetails: () => void;
  dispatchResetClientAadharUniqueCheckSuccess: () => void;
  dispatchResetClientAadharUniqueCheckError: () => void;
  dispatchResetClientAadharUniqueCheckMessage: () => void;
  dispatchClientAadharUniqueCheckAction: (
    data: AadhaarAndPanUniqueCheckPayloadType
  ) => void;
  dispatchResetClientPanUniqueCheckSuccess: () => void;
  dispatchResetClientPanUniqueCheckError: () => void;
  dispatchResetClientPanUniqueCheckMessage: () => void;
  dispatchClientPanUniqueCheckAction: (
    data: AadhaarAndPanUniqueCheckPayloadType
  ) => void;
  dispatchAddClientDirectoryAction: (
    data: AddClientDirectoryPayloadType
  ) => void;
};
const AddClient = ({
  history,
  token,
  statusCode,
  success,
  fetching,
  error,
  isState,
  isCity,
  clientAadharUniqueCheckMessage,
  clientPanUniqueCheckMessage,
  clientAadharUniqueCheckFetching,
  clientPanUniqueCheckFetching,
  dispatchResetClientDirectorySuccess,
  dispatchResetClientDirectoryError,
  dispatchResetClientDirectoryMessage,
  dispatchResetClientDirectoryStatusCode,
  dispatchResetSession,
  dispatchResetSingleClientDirectory,
  dispatchResetClientDirectoryList,
  dispatchAddClientDirectoryAction,
  dispatchResetGstDetails,
  dispatchClientAadharUniqueCheckAction,
  dispatchResetClientAadharUniqueCheckSuccess,
  dispatchResetClientAadharUniqueCheckError,
  dispatchResetClientAadharUniqueCheckMessage,
  dispatchClientPanUniqueCheckAction,
  dispatchResetClientPanUniqueCheckSuccess,
  dispatchResetClientPanUniqueCheckError,
  dispatchResetClientPanUniqueCheckMessage,
}: AppProps) => {
  useEffect(() => {
    dispatchResetClientDirectorySuccess();
    dispatchResetClientDirectoryError();
    dispatchResetClientDirectoryMessage();
    dispatchResetClientDirectoryStatusCode();
    dispatchResetSingleClientDirectory();
    dispatchResetGstDetails();
    dispatchResetClientAadharUniqueCheckSuccess();
    dispatchResetClientAadharUniqueCheckError();
    dispatchResetClientAadharUniqueCheckMessage();
    dispatchResetClientPanUniqueCheckSuccess();
    dispatchResetClientPanUniqueCheckError();
    dispatchResetClientPanUniqueCheckMessage();
  }, []);

  const handleClientPanUniqueCheck = (data: any) => {
    if (token) {
      const finalData = {
        token,
        ...data,
      };
      dispatchClientPanUniqueCheckAction(finalData);
    }
  };
  const handleClientAadharUniqueCheck = (data: any) => {
    if (token) {
      const finalData = {
        token,
        ...data,
      };
      dispatchClientAadharUniqueCheckAction(finalData);
    }
  };

  const handleSubmit = (data: any) => {
    if (token) {
      const finalData = {
        token,
        ...data,
      };
      dispatchAddClientDirectoryAction(finalData);
    }
  };
  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetClientDirectoryError();
            }}
          />
        );
      }
    }

    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={`Client Added Successfully!`}
          buttonText="OK"
          onPress={() => {
            dispatchResetClientDirectoryList();
            dispatchResetClientDirectorySuccess();
            history?.push("/client-directory-list");
          }}
          statusCode={statusCode}
        />
      );
    }
  };
  return (
    <>
      <div>
        <CommonHeader title="Add Client" />
      </div>
      <ClientDirectoryForm
        clientAadharUniqueCheckFetching={clientAadharUniqueCheckFetching}
        clientPanUniqueCheckFetching={clientPanUniqueCheckFetching}
        clientAadharUniqueCheckMessage={clientAadharUniqueCheckMessage}
        clientPanUniqueCheckMessage={clientPanUniqueCheckMessage}
        dispatchResetClientAadharUniqueCheckMessage={
          dispatchResetClientAadharUniqueCheckMessage
        }
        dispatchResetClientPanUniqueCheckMessage={
          dispatchResetClientPanUniqueCheckMessage
        }
        history={history}
        handleSubmit={handleSubmit}
        handleClientPanUniqueCheck={handleClientPanUniqueCheck}
        handleClientAadharUniqueCheck={handleClientAadharUniqueCheck}
        isCity={isCity}
        isState={isState}
      />
      {handleErrorModal()}
      <Toaster />
      {fetching && <Loader />}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.clientDirectory.success,
  fetching: state.clientDirectory.fetching,
  statusCode: state.clientDirectory.statusCode,
  error: state.clientDirectory.error,
  clientAadharUniqueCheckFetching:
    state.clientDirectory.clientAadharUniqueCheckFetching,
  clientAadharUniqueCheckMessage:
    state.clientDirectory.clientAadharUniqueCheckMessage,
  clientPanUniqueCheckFetching:
    state.clientDirectory.clientPanUniqueCheckFetching,
  clientPanUniqueCheckMessage:
    state.clientDirectory.clientPanUniqueCheckMessage,
  isState: state.masterData.isState,
  isCity: state.masterData.isCity,
});
const dispatchToProps = (dispatch: any) => ({
  dispatchResetClientDirectorySuccess: () =>
    dispatch(resetClientDirectorySuccess()),
  dispatchResetClientDirectoryError: () =>
    dispatch(resetClientDirectoryError()),
  dispatchResetClientDirectoryMessage: () =>
    dispatch(resetClientDirectoryMessage()),
  dispatchResetClientDirectoryStatusCode: () =>
    dispatch(resetClientDirectoryStatusCode()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSingleClientDirectory: () =>
    dispatch(resetSingleClientDirectory()),
  dispatchResetClientDirectoryList: () => dispatch(resetClientDirectoryList()),
  dispatchAddClientDirectoryAction: (data: AddClientDirectoryPayloadType) =>
    dispatch(addClientDirectoryAction(data)),
  dispatchResetGstDetails: () => dispatch(resetGstDetails()),
  dispatchClientAadharUniqueCheckAction: (
    data: AadhaarAndPanUniqueCheckPayloadType
  ) => dispatch(clientAadharUniqueCheckAction(data)),
  dispatchClientPanUniqueCheckAction: (
    data: AadhaarAndPanUniqueCheckPayloadType
  ) => dispatch(clientPanUniqueCheckAction(data)),
  dispatchResetClientAadharUniqueCheckSuccess: () =>
    dispatch(resetClientAadharUniqueCheckSuccess()),
  dispatchResetClientAadharUniqueCheckError: () =>
    dispatch(resetClientAadharUniqueCheckError()),
  dispatchResetClientAadharUniqueCheckMessage: () =>
    dispatch(resetClientAadharUniqueCheckMessage()),
  dispatchResetClientPanUniqueCheckSuccess: () =>
    dispatch(resetClientPanUniqueCheckSuccess()),
  dispatchResetClientPanUniqueCheckError: () =>
    dispatch(resetClientPanUniqueCheckError()),
  dispatchResetClientPanUniqueCheckMessage: () =>
    dispatch(resetClientPanUniqueCheckMessage()),
});

export default connect(mapStateToProps, dispatchToProps)(AddClient);
